const JAVA_MAX_INTEGER = 2147483647;
const JAVA_MIN_INTEGER = -2147483648;

const RE_ALPHANUMERIC = /^\w*$/;
const RE_INTEGER = /^-?\d\d*$/;
const RE_NUMERIC = /(^-?\d\d*\.\d*$)|(^-?\d\d*$)|(^-?\.\d\d*$)/;
const RE_PHONE = /^[\d\w\s\.()+-]+$/;

// RegExp is taken from http://stackoverflow.com/questions/46155/validate-email-address-in-javascript
// Modified to allow local domain name with no TLD (just replaced + with * after '+\.)'
const RE_EMAIL = /^(([^<>()[\]\.,;:\s@\"]+(\.[^<>()[\]\.,;:\s@\"]+)*)|(\".+\"))@(([^<>()[\]\.,;:\s@\"]+\.)*[^<>()[\]\.,;:\s@\"]{2,})$/i;

// RegExp for URL is taken from https://gist.github.com/dperini/729294#file-regex-weburl-js
const RE_URL = new RegExp("^" +
	// protocol identifier
	"(?:(?:https?|ftp):\/\/)" +
	// user:pass authentication
	"(?:\\S+(?::\\S*)?@)?" +
	"(?:" +
	// IP address exclusion
	// private & local networks
	"(?!(?:10|127)(?:\\.\\d{1,3}){3})" +
	"(?!(?:169\\.254|192\\.168)(?:\\.\\d{1,3}){2})" +
	"(?!172\\.(?:1[6-9]|2\\d|3[0-1])(?:\\.\\d{1,3}){2})" +
	// IP address dotted notation octets
	// excludes loopback network 0.0.0.0
	// excludes reserved space >= 224.0.0.0
	// excludes network & broacast addresses
	// (first & last IP address of each class)
	"(?:[1-9]\\d?|1\\d\\d|2[01]\\d|22[0-3])" +
	"(?:\\.(?:1?\\d{1,2}|2[0-4]\\d|25[0-5])){2}" +
	"(?:\\.(?:[1-9]\\d?|1\\d\\d|2[0-4]\\d|25[0-4]))" +
	"|" +
	// host name
	"(?:(?:[a-z\\u00a1-\\uffff0-9]-*)*[a-z\\u00a1-\\uffff0-9]+)" +
	// domain name
	"(?:\\.(?:[a-z\\u00a1-\\uffff0-9]-*)*[a-z\\u00a1-\\uffff0-9]+)*" +
	// TLD identifier
	"(?:\\.(?:[a-z\\u00a1-\\uffff]{2,}))" +
	// TLD may end with dot
	"\\.?" +
	")" +
	// port number
	"(?::\\d{2,5})?" +
	// resource path
	"(?:[/?#]\\S*)?" +
	"$", "i");

export function isAlphaNumeric(value: string): boolean {
	return RE_ALPHANUMERIC.test(value);
}

export function isEmailAddress(value: string): boolean {
	return RE_EMAIL.test(value);
}

export function isInteger(value: string): boolean {
	return RE_INTEGER.test(value);
}

export function isIntegerOutOfBounds(value: number): boolean {
	return (value < JAVA_MIN_INTEGER) || (JAVA_MAX_INTEGER < value);
}

export function isNumeric(value: string): boolean {
	if (value.toString()
		.includes("e-")) {
		value = Number(value)
			.toFixed(Number(value.toString()
				.split("e-")[1]));
	}

	return RE_NUMERIC.test(value);
}

export function isNumericOutOfBounds(value: number): boolean {
	return (value < Number.MIN_SAFE_INTEGER) || (Number.MAX_SAFE_INTEGER < value);
}

export function isPhone(value: string): boolean {
	return RE_PHONE.test(value);
}

export function isUrl(value: string): boolean {
	return RE_URL.test(value);
}